"use client";

import { useCallback } from "react";
import { useParams, useRouter } from 'next/navigation';
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { defaultAddToCartApi } from "@/clientSideApi/cart";
import { generalEcomEvent } from "@/lib/utils";

const CardButton = ({ name, pk, price, category, productSlug }) => {

  const { categorySlug } = useParams();
  const router = useRouter();

  const handleAddToCard = useCallback(async() => {
    const apiResponse = await defaultAddToCartApi(categorySlug, productSlug);
    if(!apiResponse)  return;
    router.push(`/cart`);
    generalEcomEvent({
      event: "add_to_cart",
      other: {
        currency: "INR",
        value: price,
      },
      items: [
        {
          item_id: pk,
          item_name: name,
          item_category: category?.name,
          price: price,
          item_brand: "ORNAZ",
          item_url: `${process.env.NEXT_PUBLIC_API_URL}/${categorySlug}/${productSlug}/`,
        },
      ],
    });
  }, [ categorySlug, productSlug, router, pk, name, price, category ])
  
  return (
    <>
      <Button 
        aria-label="add to cart"
        variant="outline" 
        className="
          h-[33px] w-full  text-xs 
          lg:text-sm select-none bg-[#45D4D5]
          text-font-button hover:drop-shadow
          hover:bg-[#56f0f1]
          border-[0.5px] border-[#45D4D5]
        "
        onClick={handleAddToCard}
      >
        Add to Cart
      </Button>
      <Link
        href={`/book-an-appointment/${pk}`}
        aria-label={`book an appointment for ${name}`}
        className="
          h-[33px] w-full bg-white rounded-md
          flex items-center justify-center
          text-xs lg:text-sm hover:bg-white
          select-none text-font-button hover:drop-shadow
          border-[0.5px] border-gray-400
        "
      >
        Book Your Appointment
      </Link>
    </>
  );
};

export default CardButton;
